import { render, staticRenderFns } from "./DataInfoBadge.vue?vue&type=template&id=3bbc1a72&"
import script from "./DataInfoBadge.vue?vue&type=script&lang=js&"
export * from "./DataInfoBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports